import Panel from './Panel';
import { getPanelClass, getAppData } from 'larasnap';
import { remove } from 'larasnap/support';
import merge from 'lodash-es/merge';
import cloneDeep from 'lodash-es/cloneDeep';
import isObject from 'lodash-es/isObject';
import isMatch from 'lodash-es/isMatch';

const data = getAppData('panels');
const defaultProps = data.default;
const templates = data.templates;
const panels = [];

const getPanel = id => panels.find(x => x.getId() === id);

export const destoryPanel = id => {
    remove(panels, x => x.getId() === id);
};

export const getPanels = props =>
    panels.reduce((panels, panel) => {
        return isMatch(panel.getProps(), props)
            ? panels.concat([panel])
            : panels;
    }, []);

export const getTemplate = param => {
    let namespace, name;

    if (param.includes('.')) {
        const a = param.split('.');
        namespace = a[0];
        name = a[1];
    } else {
        namespace = getAppData('namespace');
        name = param;
    }

    let template;

    // First check the specific namespace
    if (templates[namespace]?.[name]) {
        template = templates[namespace][name];
        template.namespace = namespace;
        return template;
    }
    // Then check the common namespace
    else if (templates['common'][name]) {
        template = templates['common'][name];
        template.namespace = 'common';
        return template;
    }
    // Lastly merge all namespaces together and use the first match
    else {
        const allTemplates = Object.entries(templates).reduce(
            (allTemplates, [namespace, templates]) =>
                Object.assign(
                    allTemplates,
                    Object.entries(templates).reduce(
                        (templates, [name, template]) => ({
                            ...templates,
                            [name]: { ...template, namespace },
                        }),
                        {},
                    ),
                ),
            {},
        );
        return allTemplates[name];
    }
};

const createPanel = (name, ...params) => {
    const template = getTemplate(name);

    if (!template) {
        console.error(
            `[PanelManager] Error, no template with name '${name}' exists`,
        );
        return;
    }

    const props = merge(cloneDeep(defaultProps), cloneDeep(template));

    props.routes = props.routes.map(([httpMethod, url, method]) => ({
        httpMethod,
        name: url.split('/')[0],
        method,
    }));

    props.name = name;
    props.id = `panel-${name}-${params[0]}`;

    const existingPanel = getPanel(props.id);

    if (existingPanel && !template.allowDuplicates) {
        existingPanel.focus();
        existingPanel.shake();
    } else {
        let cls = getPanelClass(name);
        if (!cls) {
            cls = Panel;
        }

        if (typeof cls.getClass === 'function') {
            const newCls = cls.getClass(...params);
            if (typeof newCls === 'function') {
                cls = newCls;
            }
        }

        const panel = new cls(props);
        panels.push(panel);
        return panel;
    }
};

export const createLoadPanelOptions = (name, ...params) => {
    let options;

    if (typeof name === 'string') {
        options = {
            name,
            params,
        };
    } else if (isObject(name)) {
        options = name;
        if (!options.params) options.params = [];
    }

    if (options.params.length > 0) {
        options.id = options.params[0];
    }

    return options;
};

export const loadPanel = (...args) => {
    const {
        name,
        params,
        row,
        parent,
        id,
        queryString,
        postData,
    } = createLoadPanelOptions(...args);

    const panel = createPanel(name, ...params);

    if (panel) {
        if (row) panel.setSnapGridRow(row);
        if (parent) panel.setParent(parent);

        panel.init();

        if (panel.getBoundSnapGrid()) {
            panel.getBoundSnapGrid().bind('Panel', panel.getName(), id);
        }

        panel.load({ params, queryString, postData });
    }

    return panel;
};

window.loadPanel = loadPanel;
